import React, { useEffect, useRef, useState, useContext } from "react";
import MenuContext from "../../MenuContext";
import StoreContext from "../../StoreContext";
import "./menuItems.scss";
import { RiArrowLeftSLine } from "react-icons/ri";
import { RiArrowRightSLine } from "react-icons/ri";

function MenuItems2(props) {
  const storeContext = useContext(StoreContext);
  const menuContext = useContext(MenuContext);
  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [activeSubCategory, setActiveSubCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const categoryRefs = useRef({});
  const isScrollLocked = useRef(false);

  const allCategories = menuContext.menu
    ? Object.keys(menuContext.menu).flatMap(menuName =>
      menuContext.menu[menuName].map(category => {
        const subCategories = (category.subcategories || []).map(sub => ({
          key: `${menuName}-${category.category}-${sub.subCategoryName}`,
          parentKey: `${menuName}-${category.category}`,
          label: sub.subCategoryName,
          subCategory: sub.subCategoryName,
        }));

        return {
          key: `${menuName}-${category.category}`,
          label: category.category,
          category: category.category,
          menuName,
          subCategories,
        };
      })
    ) : [];

  useEffect(() => {
    const targetClass = document.querySelector('.category-master');
    const otherElement = document.querySelector('.store_is_not_active');

    if (otherElement) {
      if (targetClass) {
        targetClass.style.top = '50px'; // Class exists
      } else {
        targetClass.style.top = '10px'; // Class does NOT exist
      }
    }
  }, []);

  useEffect(() => {
    if (!menuContext.menu || allCategories.length === 0) return;

    setActiveCategory(allCategories[0].key);
    setSelectedCategory(allCategories[0]);

    if (allCategories[0].subCategories.length > 0) {
      setActiveSubCategory(allCategories[0].subCategories[0].key);
      setSelectedSubCategory(allCategories[0].subCategories[0]);
    }
  }, [menuContext.menu]);

  useEffect(() => {
    if (!menuContext.menu) return;

    Object.keys(menuContext.menu).forEach(menuName => {
      (menuContext.menu[menuName] || []).forEach(category => {
        const categoryKey = `${menuName}-${category.category}`;
        if (!categoryRefs.current[categoryKey]) {
          categoryRefs.current[categoryKey] = React.createRef();
        }

        (category.subcategories || []).forEach(sub => {
          const subKey = `${menuName}-${category.category}-${sub.subCategoryName}`;
          if (!categoryRefs.current[subKey]) {
            categoryRefs.current[subKey] = React.createRef();
          }
        });
      });
    });
  }, [menuContext.menu]);

  const scrollToItemsSectionWithOffset = (ref) => {
    const element = ref?.current;
    if (!element) return;

    const baseOffset = document.querySelector(".category-master")?.offsetHeight || 0;
    const extraOffset = document.querySelector(".store_is_not_active") ? 50 : 0;
    const totalOffset = baseOffset + extraOffset;
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementTop - totalOffset,
      behavior: "smooth",
    });
  };

  const handleCategoryClick = (i) => {
    isScrollLocked.current = true; // Disable scroll updates temporarily
    var key = i.key;

    var cat = i.category.replace(/\s/g, "");
    var el = document.getElementById(`${cat}Button`);
    var menu_categories = document.getElementById(`menu_categories`);
    const child = el.getBoundingClientRect();
    const parent = menu_categories.getBoundingClientRect();
    var isOverflowingRightSide = child.right + 35 > menu_categories.clientWidth;
    var isOverflowingLeftSide = child.left - 35 < parent.left;
    if (isOverflowingRightSide) {
      menu_categories.scrollLeft +=
        child.right - menu_categories.clientWidth + 120;
    }
    if (isOverflowingLeftSide) {
      menu_categories.scrollLeft -= parent.left + child.left + 120;
    }

    scrollToItemsSectionWithOffset(categoryRefs.current[key]);

    setActiveCategory(key);
    if (i.subCategories.length > 0) {
      setActiveSubCategory(i.subCategories[0].key);
    } else {
      setActiveSubCategory();
    }
    setSelectedCategory(i);

    setTimeout(() => {
      isScrollLocked.current = false;
    }, 2000);
  };

  const handleSubCategoryClick = (i) => {
    isScrollLocked.current = true; // Disable scroll updates temporarily
    var key = i.key;
    var parentKey = i.parentKey;

    var subCat = i.subCategory.replace(/\s/g, "");
    var el = document.getElementById(`${subCat}Button`);
    var menu_sub_categories = document.getElementById(`menu_sub_categories`);
    const child = el.getBoundingClientRect();
    const parent = menu_sub_categories.getBoundingClientRect();
    var isOverflowingRightSide = child.right + 35 > menu_sub_categories.clientWidth;
    var isOverflowingLeftSide = child.left - 35 < parent.left;
    if (isOverflowingRightSide) {
      menu_sub_categories.scrollLeft +=
        child.right - menu_sub_categories.clientWidth + 200;
    }
    if (isOverflowingLeftSide) {
      menu_sub_categories.scrollLeft -= parent.left + child.left + 200;
    }

    scrollToItemsSectionWithOffset(categoryRefs.current[key]);

    setActiveCategory(parentKey);
    setActiveSubCategory(key);
    setSelectedSubCategory(i);

    setTimeout(() => {
      isScrollLocked.current = false;
    }, 2000);
  };

  const handleCategoriesScroll = () => {
    if (isScrollLocked.current) return;

    for (const cat of allCategories) {
      const ref = categoryRefs.current[cat.key];
      if (ref?.current) {
        const top = ref.current.getBoundingClientRect().top;
        if (top >= 50 && top < 200) {
          setActiveCategory(cat.key);
          setSelectedCategory(cat);

          scrollButtonIntoView(`${cat.category.replace(/\s/g, "")}Button`, "menu_categories");

          if (cat.subCategories.length > 0) {
            setActiveSubCategory(cat.subCategories[0].key);
            setSelectedSubCategory(cat.subCategories[0])
          }
          break;
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleCategoriesScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleCategoriesScroll);
  }, []);

  const handleSubCategoriesScroll = () => {
    if (isScrollLocked.current) return;
    if (!selectedCategory || !selectedCategory.subCategories) return;

    for (const sub of selectedCategory.subCategories) {
      const ref = categoryRefs.current[sub.key];
      if (ref?.current) {
        const top = ref.current.getBoundingClientRect().top;
        if (top >= 50 && top < 200) {
          setActiveSubCategory(sub.key);
          setSelectedSubCategory(sub);

          scrollButtonIntoView(`${sub.subCategory.replace(/\s/g, "")}Button`, "menu_sub_categories", 200);

          break;
        }
      }
    }
  };

  const scrollButtonIntoView = (buttonId, containerId, padding = 120) => {
    const el = document.getElementById(buttonId);
    const container = document.getElementById(containerId);

    if (!el || !container) return;

    const child = el.getBoundingClientRect();
    const parent = container.getBoundingClientRect();

    const isOverflowingRight = child.right + 35 > parent.right;
    const isOverflowingLeft = child.left - 35 < parent.left;

    if (isOverflowingRight) {
      container.scrollLeft += child.right - parent.right + padding;
    }

    if (isOverflowingLeft) {
      container.scrollLeft -= parent.left - child.left + padding;
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleSubCategoriesScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleSubCategoriesScroll);
  }, [selectedCategory]);

  async function scrollLeft() {
    const buttonLeft = document.getElementById("scroll_button_left");
    buttonLeft.onclick = function () {
      document.getElementById("menu_categories").scrollLeft -= 175;
    };
  }

  async function scrollRight() {
    const buttonRight = document.getElementById("scroll_button_right");
    buttonRight.onclick = function () {
      document.getElementById("menu_categories").scrollLeft += 175;
    };
  }

  async function toggleItemModal(item) {
    item.active = "Active";
    props.setSelectedItem(item);
    props.setShowItemModal(true);
  }

  return (
    <div className="menu-container">
      <div className="category-master">
        <div className="category-container">
          <div
            className="scroll_button scroll_button_left"
            onClick={scrollLeft}
          >
            <RiArrowLeftSLine id="scroll_button_left" />
          </div>
          <div className="category-bar" id="menu_categories">
            {allCategories.map(cat => (
              <button
                key={cat.key}
                id={`${cat.category.replace(/\s/g, "")}Button`}
                onClick={(e) => handleCategoryClick(cat)}
                className="category-button"
                style={activeCategory === cat.key ? {
                  backgroundColor: "white",
                  color: `${storeContext.color}`,
                  borderBottom: `4px solid ${storeContext.color}`,
                  fontWeight: "900",
                  borderBottomLeftRadius: "3px",
                  borderBottomRightRadius: "3px",
                } : {}}
              >
                {cat.label}
              </button>
            ))}
          </div>
          <div
            className="scroll_button scroll_button_right"
            onClick={scrollRight}
          >
            <RiArrowRightSLine id="scroll_button_right" />
          </div>
        </div>

        {selectedCategory?.subCategories?.length > 0 && (
          <div className="sub-category-container">
            <div className="subcategory-bar" id="menu_sub_categories">
              {selectedCategory.subCategories.map(sub => (
                <button
                  key={sub.key}
                  id={`${sub.subCategory.replace(/\s/g, "")}Button`}
                  onClick={(e) => handleSubCategoryClick(sub)}
                  className="subcategory-button"
                  style={activeSubCategory === sub.key ? {
                    backgroundColor: "white",
                    color: `${storeContext.color}`,
                    borderBottom: `4px solid ${storeContext.color}`,
                    fontWeight: "900",
                    borderBottomLeftRadius: "3px",
                    borderBottomRightRadius: "3px",
                  } : {}}
                >
                  {sub.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>


      <div className="items-section">
        {allCategories.map(cat => {
          const categoryData = menuContext.menu[cat.menuName].find(
            c => c.category === cat.category
          );

          const subcategories = categoryData?.subcategories || [];
          const hasSubcategories = subcategories.length > 0;
          const categoryItems = categoryData?.items || [];

          return (
            <div
              key={cat.key}
              ref={categoryRefs.current[cat.key]}
              className="category-section"
            >
              <div className="categoryName">{cat.label}</div>

              {!hasSubcategories &&
                categoryItems.map(item => (
                  <div key={item.menuItemID} className="item-card" onClick={() => toggleItemModal(item)}>
                    <div className="itemName">{item.itemName}</div>
                    {item.itemDescription && <p className="description">{item.itemDescription}</p>}
                    <p className="price">${item.itemPrice.toFixed(2)}</p>
                  </div>
                ))}

              {hasSubcategories &&
                subcategories.map(sub => (
                  <div
                    key={`${cat.key}-${sub.subCategoryName}`}
                    ref={categoryRefs.current[`${cat.key}-${sub.subCategoryName}`]}
                    className="subcategory-section"
                  >
                    <div className="subcategoryName">{sub.subCategoryName}</div>
                    {(sub.items || []).map(item => (
                      <div key={item.menuItemID} className="item-card" onClick={() => toggleItemModal(item)}>
                        <div className="itemName">{item.itemName}</div>
                        {item.itemDescription && <p className="description">{item.itemDescription}</p>}
                        <p className="price">${item.itemPrice.toFixed(2)}</p>
                      </div>
                    ))}
                  </div>
                ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MenuItems2;
